<template>
  <div>
    您没有该功能的操作权限，请联系管理员开通
    <!-- <el-button @click="goBack()" type="primary">返回</el-button> -->
  </div>
</template>

<script>
export default {
  name: 'SsgNoPermission',
  data() {
    return {
      
      
    }
  },
  methods:{
    // goBack(){
    //   window.history.back()
    // }
  }
}
</script>

